import { render, staticRenderFns } from "./InternalTransferDataTable.vue?vue&type=template&id=374287e4&scoped=true"
import script from "./InternalTransferDataTable.vue?vue&type=script&lang=js"
export * from "./InternalTransferDataTable.vue?vue&type=script&lang=js"
import style0 from "./InternalTransferDataTable.vue?vue&type=style&index=0&id=374287e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374287e4",
  null
  
)

export default component.exports